// extracted by mini-css-extract-plugin
module.exports = {"title":"error_title__puYGA","subTitle":"error_subTitle__kKIHL","text":"error_text__Cabeh","button":"error_button__fmdHC"};